// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file notification.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file notification.proto.
 */
export const file_notification: GenFile = /*@__PURE__*/
  fileDesc("ChJub3RpZmljYXRpb24ucHJvdG8SCXJhY2Nvb25haSJYCgxOb3RpZmljYXRpb24SKwoEdHlwZRgBIAIoDjIdLnJhY2Nvb25haS5Ecml2ZXJOb3RpZmljYXRpb24SDQoFdGl0bGUYAiACKAkSDAoEYm9keRgDIAIoCSqBAwoSRHJpdmVyTm90aWZpY2F0aW9uEiEKHURSSVZFUl9OT1RJRklDQVRJT05fVU5ERUZJTkVEEAASIgoeRFJJVkVSX05PVElGSUNBVElPTl9WQUxJREFUSU9OEAESJQohRFJJVkVSX05PVElGSUNBVElPTl9ST1VURV9DUkVBVEVEEAISJwojRFJJVkVSX05PVElGSUNBVElPTl9ST1VURV9DQU5DRUxMRUQQAxItCilEUklWRVJfTk9USUZJQ0FUSU9OX1JPVVRFX0ZPUkNFX0NPTVBMRVRFRBAEEiUKIURSSVZFUl9OT1RJRklDQVRJT05fU0hJRlRfU1RBUlRFRBAFEicKI0RSSVZFUl9OT1RJRklDQVRJT05fU0hJRlRfQ09NUExFVEVEEAYSKQolRFJJVkVSX05PVElGSUNBVElPTl9BUlJJVkVEX0FUX1BJQ0tVUBAHEioKJkRSSVZFUl9OT1RJRklDQVRJT05fQVJSSVZFRF9BVF9TQ0FMSU5HEAgq5wMKEU5vdGlmaWNhdGlvbkV2ZW50EiAKHE5PVElGSUNBVElPTl9FVkVOVF9VTkRFRklORUQQABIiCh5OT1RJRklDQVRJT05fRVZFTlRfSk9CX0NSRUFURUQQARIjCh9OT1RJRklDQVRJT05fRVZFTlRfSk9CX0FTU0lHTkVEEAISIgoeTk9USUZJQ0FUSU9OX0VWRU5UX0pPQl9FTlJPVVRFEAMSJAogTk9USUZJQ0FUSU9OX0VWRU5UX0pPQl9DT01QTEVURUQQBBIoCiROT1RJRklDQVRJT05fRVZFTlRfQ09OVFJBQ1RfRVhQSVJJTkcQBRIyCi5OT1RJRklDQVRJT05fRVZFTlRfV09SS19BQ1RfQU5EX0lOVk9JQ0VfSVNTVUVEEAYSJQohTk9USUZJQ0FUSU9OX0VWRU5UX1JPVVRFX0FTU0lHTkVEEAcSJAogTk9USUZJQ0FUSU9OX0VWRU5UX1JPVVRFX0NIQU5HRUQQCBImCiJOT1RJRklDQVRJT05fRVZFTlRfVFJVQ0tfQlJFQUtET1dOEAkSIgoeTk9USUZJQ0FUSU9OX0VWRU5UX0pPQl9TS0lQUEVEEAoSJgoiTk9USUZJQ0FUSU9OX0VWRU5UX09WRVJEVUVfUEFZTUVOVBALKpsBChNOb3RpZmljYXRpb25DaGFubmVsEiIKHk5PVElGSUNBVElPTl9DSEFOTkVMX1VOREVGSU5FRBAAEh4KGk5PVElGSUNBVElPTl9DSEFOTkVMX0VNQUlMEAESIQodTk9USUZJQ0FUSU9OX0NIQU5ORUxfV0hBVFNBUFAQAhIdChlOT1RJRklDQVRJT05fQ0hBTk5FTF9QVVNIEANCBloELi9wYg");

/**
 * @generated from message raccoonai.Notification
 */
export type Notification = Message<"raccoonai.Notification"> & {
  /**
   * @generated from field: required raccoonai.DriverNotification type = 1;
   */
  type: DriverNotification;

  /**
   * @generated from field: required string title = 2;
   */
  title: string;

  /**
   * @generated from field: required string body = 3;
   */
  body: string;
};

/**
 * @generated from message raccoonai.Notification
 */
export type NotificationJson = {
  /**
   * @generated from field: required raccoonai.DriverNotification type = 1;
   */
  type?: DriverNotificationJson;

  /**
   * @generated from field: required string title = 2;
   */
  title?: string;

  /**
   * @generated from field: required string body = 3;
   */
  body?: string;
};

/**
 * Describes the message raccoonai.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification, {jsonType: NotificationJson}> = /*@__PURE__*/
  messageDesc(file_notification, 0);

/**
 * @generated from enum raccoonai.DriverNotification
 */
export enum DriverNotification {
  /**
   * @generated from enum value: DRIVER_NOTIFICATION_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_VALIDATION = 1;
   */
  VALIDATION = 1,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_ROUTE_CREATED = 2;
   */
  ROUTE_CREATED = 2,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_ROUTE_CANCELLED = 3;
   */
  ROUTE_CANCELLED = 3,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_ROUTE_FORCE_COMPLETED = 4;
   */
  ROUTE_FORCE_COMPLETED = 4,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_SHIFT_STARTED = 5;
   */
  SHIFT_STARTED = 5,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_SHIFT_COMPLETED = 6;
   */
  SHIFT_COMPLETED = 6,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_ARRIVED_AT_PICKUP = 7;
   */
  ARRIVED_AT_PICKUP = 7,

  /**
   * @generated from enum value: DRIVER_NOTIFICATION_ARRIVED_AT_SCALING = 8;
   */
  ARRIVED_AT_SCALING = 8,
}

/**
 * @generated from enum raccoonai.DriverNotification
 */
export type DriverNotificationJson = "DRIVER_NOTIFICATION_UNDEFINED" | "DRIVER_NOTIFICATION_VALIDATION" | "DRIVER_NOTIFICATION_ROUTE_CREATED" | "DRIVER_NOTIFICATION_ROUTE_CANCELLED" | "DRIVER_NOTIFICATION_ROUTE_FORCE_COMPLETED" | "DRIVER_NOTIFICATION_SHIFT_STARTED" | "DRIVER_NOTIFICATION_SHIFT_COMPLETED" | "DRIVER_NOTIFICATION_ARRIVED_AT_PICKUP" | "DRIVER_NOTIFICATION_ARRIVED_AT_SCALING";

/**
 * Describes the enum raccoonai.DriverNotification.
 */
export const DriverNotificationSchema: GenEnum<DriverNotification, DriverNotificationJson> = /*@__PURE__*/
  enumDesc(file_notification, 0);

/**
 * Business events users can be notified about. Final list pending.
 *
 * @generated from enum raccoonai.NotificationEvent
 */
export enum NotificationEvent {
  /**
   * @generated from enum value: NOTIFICATION_EVENT_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: NOTIFICATION_EVENT_JOB_CREATED = 1;
   */
  JOB_CREATED = 1,

  /**
   * @generated from enum value: NOTIFICATION_EVENT_JOB_ASSIGNED = 2;
   */
  JOB_ASSIGNED = 2,

  /**
   * @generated from enum value: NOTIFICATION_EVENT_JOB_ENROUTE = 3;
   */
  JOB_ENROUTE = 3,

  /**
   * @generated from enum value: NOTIFICATION_EVENT_JOB_COMPLETED = 4;
   */
  JOB_COMPLETED = 4,

  /**
   * @generated from enum value: NOTIFICATION_EVENT_CONTRACT_EXPIRING = 5;
   */
  CONTRACT_EXPIRING = 5,

  /**
   * @generated from enum value: NOTIFICATION_EVENT_WORK_ACT_AND_INVOICE_ISSUED = 6;
   */
  WORK_ACT_AND_INVOICE_ISSUED = 6,

  /**
   * Driver: a route is assigned to you (created approved, or approved later).
   *
   * @generated from enum value: NOTIFICATION_EVENT_ROUTE_ASSIGNED = 7;
   */
  ROUTE_ASSIGNED = 7,

  /**
   * Driver: jobs were added to or removed from your route in progress.
   *
   * @generated from enum value: NOTIFICATION_EVENT_ROUTE_CHANGED = 8;
   */
  ROUTE_CHANGED = 8,

  /**
   * Mechanic: a driver reported a truck breakdown.
   *
   * @generated from enum value: NOTIFICATION_EVENT_TRUCK_BREAKDOWN = 9;
   */
  TRUCK_BREAKDOWN = 9,

  /**
   * Dispatcher: a driver could not do a job (blocked, no access, wrong equipment).
   *
   * @generated from enum value: NOTIFICATION_EVENT_JOB_SKIPPED = 10;
   */
  JOB_SKIPPED = 10,

  /**
   * Customer: an invoice is past its due date. Dormant until invoices live in the platform.
   *
   * @generated from enum value: NOTIFICATION_EVENT_OVERDUE_PAYMENT = 11;
   */
  OVERDUE_PAYMENT = 11,
}

/**
 * Business events users can be notified about. Final list pending.
 *
 * @generated from enum raccoonai.NotificationEvent
 */
export type NotificationEventJson = "NOTIFICATION_EVENT_UNDEFINED" | "NOTIFICATION_EVENT_JOB_CREATED" | "NOTIFICATION_EVENT_JOB_ASSIGNED" | "NOTIFICATION_EVENT_JOB_ENROUTE" | "NOTIFICATION_EVENT_JOB_COMPLETED" | "NOTIFICATION_EVENT_CONTRACT_EXPIRING" | "NOTIFICATION_EVENT_WORK_ACT_AND_INVOICE_ISSUED" | "NOTIFICATION_EVENT_ROUTE_ASSIGNED" | "NOTIFICATION_EVENT_ROUTE_CHANGED" | "NOTIFICATION_EVENT_TRUCK_BREAKDOWN" | "NOTIFICATION_EVENT_JOB_SKIPPED" | "NOTIFICATION_EVENT_OVERDUE_PAYMENT";

/**
 * Describes the enum raccoonai.NotificationEvent.
 */
export const NotificationEventSchema: GenEnum<NotificationEvent, NotificationEventJson> = /*@__PURE__*/
  enumDesc(file_notification, 1);

/**
 * @generated from enum raccoonai.NotificationChannel
 */
export enum NotificationChannel {
  /**
   * @generated from enum value: NOTIFICATION_CHANNEL_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: NOTIFICATION_CHANNEL_EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * @generated from enum value: NOTIFICATION_CHANNEL_WHATSAPP = 2;
   */
  WHATSAPP = 2,

  /**
   * @generated from enum value: NOTIFICATION_CHANNEL_PUSH = 3;
   */
  PUSH = 3,
}

/**
 * @generated from enum raccoonai.NotificationChannel
 */
export type NotificationChannelJson = "NOTIFICATION_CHANNEL_UNDEFINED" | "NOTIFICATION_CHANNEL_EMAIL" | "NOTIFICATION_CHANNEL_WHATSAPP" | "NOTIFICATION_CHANNEL_PUSH";

/**
 * Describes the enum raccoonai.NotificationChannel.
 */
export const NotificationChannelSchema: GenEnum<NotificationChannel, NotificationChannelJson> = /*@__PURE__*/
  enumDesc(file_notification, 2);

